import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { Announcement } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  imports: [CommonModule, TranslocoPipe, RouterLink],
  selector: 'bezugsrecht-announcement-list-item-wahldividende',
  templateUrl: './announcement-list-item-wahldividende.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BezugsrechtAnnouncementListItemWahldividendeComponent {
  @Input() public announcement?: Announcement;
  public wahldividendeRoute = commonRoutes.postlogin.wahldividende;
}
